import React, { useEffect } from 'react'
import Layout from "../Layout"
import FormUpload1 from '../../components/dosen/FormUpload1'
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { getMe } from "../../features/authSlice"

const Upload1 = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isError, isSuccess } = useSelector((state) => state.auth)

    useEffect(() => {
        dispatch(getMe())
    }, [dispatch])

    if (isError) {
        return navigate("/login")
    }

    return (
        <Layout>
            <title>Form Dosen</title>
            <FormUpload1 />
        </Layout>
    )
}

export default Upload1